module.exports = __webpack_public_path__ + "img/perfilDenis.de4bf386.jpg";